import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import ReactPaginate from 'react-paginate';
import {
    Card,
    Row,
    Col,
    CardTitle,
    CardBody,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    FormText,
    Table
} from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import CustomDateModal from '../../CustomModal/CustomDateModal';
import { useSelector } from 'react-redux';

const ReceiveChallanAgrMaster = (props) => {


    //----------- REDUCE TOOLKIT -------
    const vendorState = useSelector((state) => state.vendorState);
    const branchState = useSelector((state) => state.branchState);
    const { user } = useSelector((state) => state.authState);
    const sessionData = useSelector((state) => state.sessionState);

    const [challanTable, setChallanTable] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();

    const [searchKey, setSearchkey] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [showDateModel, setShowDateModel] = useState(false);
    const [allDateSelected, setAllDateSelected] = useState(true);
    const [totalPage, setTotalPage] = useState(); // Current page for pagination


    const getChallanData = async (flag, search, page = 1, limit = 10, venderMstId) => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            // Build query params conditionally
            let queryParams = `flag=${flag ? flag : props.irFlag}&pageNo=${page}&pageSize=${limit}`;

    sessionData.session_year && (queryParams += `&session=${encodeURIComponent(sessionData.session_year)}`);
            if (search) queryParams += `&searchKey=${encodeURIComponent(search ? search : searchKey)}`;
            if (startDate) queryParams += `&startDate=${encodeURIComponent(startDate)}`;
            if (endDate) queryParams += `&endDate=${encodeURIComponent(endDate)}`;
            // if (selectedVendorId) queryParams += `&venderMasterId=${encodeURIComponent(selectedVendorId)}`;
            // if (selectedBranchId) queryParams += `&branchMasterId=${encodeURIComponent(selectedBranchId)}`;
            const vendorIdToUse = venderMstId || selectedVendorId;
            if (vendorIdToUse) {
                queryParams += `&venderMasterId=${encodeURIComponent(vendorIdToUse)}`;
            }

            // ✅ Only include branchMasterId if venderMstId is NOT passed directly
            if (selectedBranchId && !venderMstId) {
                queryParams += `&branchMasterId=${encodeURIComponent(selectedBranchId)}`;
            }

            // const response = await apiService.get(`/api/IssueReceipt/allchallan?flag=${flag}`, config)
            const response = await apiService.get(`/api/IssueReceipt/allchallan?${queryParams}`, config);
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {
                setChallanTable(response.issueReceiptMasterDetailData)
                setTotalPage(response.totalPages)

            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    };


    // useEffect(() => {
    //     getChallanData(props.irFlag, "", 1, 10);
    // }, [!challanTable]);

    const onHandleChallan = () => {
        navigate("/add_challan_receive_agr")
    }

    const onHandleDeleteChallan = async (challanId) => {

        const isDeleteConfirmed = window.confirm('Are you sure you want to delete this item?');
        if (isDeleteConfirmed) {
            try {
                let config = {
                    headers: {
                        'Content-Type': 'application/json', // Important for file upload//s
                        'accept': 'application/json'
                    }
                };

                const response = await apiService.delete(`/api/IssueReceipt/delete?challanId=${challanId}`, config)
                if (response.response && response.response.data.errors) {
                    toast.success(response.response?.data?.errors);
                }

                if (response.status === true) {
                    toast.success(response.message);
                    getChallanData()
                }
                else {
                    toast.success(response.message);
                }
            } catch (error) {
                console.log(error)
                toast.error(`SomeThing went wrong!!`);
            }
        } else {
            console.log('Deletion canceled.');
        }
    }

    const onHandleEditChallan = (challanId) => {
        let findArrayData = challanTable.find(e => e.id === challanId);
        // navigate('/add_challan_receive_agr', { state: { challanId: findArrayData.id } });

        navigate('/add_challan_receive_agr', { state: { challanId: findArrayData.id, partyId: findArrayData.pcode } });
    }

    const onHandleSearchKey = (e) => {
        let search = e.target.value;
        setSearchkey(search);
        getChallanData(props?.irFlag, search, 1, 10)
    }
    const handleApply = () => {
        setShowDateModel(true);
    }

    const handlePageClick = (data) => {
        getChallanData(props?.irFlag, "", data.selected + 1, 10)
    };



    // =======================  VENDER & BRANCH =================

    const [selectedVendorId, setSelectedVendorId] = useState("");
    const [selectedBranchId, setSelectedBranchId] = useState("");

    // Handle vendor selection change
    const selectVendorFilter = (e) => {

        let value = e.target.value
        if (!value) {
            setSelectedVendorId(value);
            setSelectedBranchId("");
        } else {
            setSelectedVendorId(value);
            setSelectedBranchId("");
            getChallanData(props?.irFlag, "", 1, 10, value);
            // getBranchMasterData(1, 10, "", value)
        }
    };


    // Handle branch selection change
    const selectbranchFilter = (e) => {
        setSelectedBranchId(e.target.value);
    };

    // useEffect(() => {
    //     getChallanData(props?.irFlag, "", 1, 10);
    // }, [selectedVendorId, selectedBranchId])

    useEffect(() => {

        if (user.user_profile != "superadmin" && selectedVendorId && selectedBranchId) {
            getChallanData(props?.irFlag, "", 1, 10);
        } else if (user.user_profile == "superadmin") {
            getChallanData(props?.irFlag, "", 1, 10);
        }

        if (vendorState.vendors.length == 1) {
            setSelectedVendorId(vendorState.vendors[0].id);
        }

        if (branchState.branches.length == 1) {
            setSelectedBranchId(branchState.branches[0].id);
        }
    }, [selectedVendorId, selectedBranchId,sessionData])

    return (
        <>
            <Col lg="12">
                {/* <Row> */}
                {/* <div className="d-flex justify-content-end mb-2">
                    <Button color="success" onClick={onHandleChallan} className="d-flex align-items-center">
                        <i className="bi bi-plus-circle mr-2"></i>
                        New
                    </Button>
                </div> */}
                {/* </Row> */}

                <Card className='bg-white pd-10 card-box mb-30'>
                    <CardTitle tag="h6" className="border-bottom p-3 mb-0 sticky-top">
                        {/* <div className="d-flex align-items-center">
                            <i className="bi bi-card-text mr-2"></i>
                            {props?.title}
                        </div>



                        <Row className="align-items-center" style={{ marginRight: '10px', width: '300px' }}>
                            <Input  id="search" name="search" placeholder="Search..." type="text" onChange={(e) => { onHandleSearchKey(e) }} />
                        </Row>

                        <Col xl={1} >
                            <Button color="primary ml-auto"
                                onClick={handleApply}
                            >
                                Filter
                            </Button>
                        </Col>


                        <Button color="primary" size="bg" onClick={onHandleChallan}>Add</Button> */}




                        <Row className="align-items-center  g-2 mb-2">
                            <Col xs={12} className="d-flex justify-content-between align-items-center">
                                {/* Title aligned left */}
                                <div className="d-flex align-items-center">
                                    <i className="bi bi-card-text mr-2"></i>
                                    {props?.title}
                                </div>

                                <div className="d-flex justify-content-end mb-2">
                                    <Button color="success" onClick={onHandleChallan} className="d-flex align-items-center">
                                        <i className="bi bi-plus-circle mr-2"></i>
                                        New
                                    </Button>
                                </div>

                            </Col>
                        </Row>

                        <Row style={{ display: "flex", justifyContent: "start" }}>


                            {/* Search and Filter in same line, centered */}
                            <Col xl={12} className="d-flex justify-content-center justify-content-md-end align-items-center gap-2">

                                <Input

                                    id="search"
                                    name="search"
                                    placeholder="Search..."
                                    type="text"
                                    // style={{ minWidth: '250px' }}
                                    onChange={(e) => onHandleSearchKey(e)}
                                />
                                <Button color="info" onClick={handleApply}>
                                    <i className="bi bi-funnel mr-1"></i>
                                    <p style={{ fontSize: 8, padding: 0, margin: 0, fontWeight: "bold" }}>Filter</p>

                                </Button>
                            </Col>

                        </Row>

                        <Row style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
                            {/* Vendor Filter */}
                            {(vendorState?.vendors.length === 0 || vendorState?.vendors.length > 1) && (
                                <Col xl={3} md={4} sm={6} style={{ marginBottom: "15px" }}>
                                    <FormGroup>
                                        <label style={{ fontWeight: "bold", marginBottom: "5px" }}>Vendor</label>
                                        <Input
                                            style={{
                                                border: "1px solid #ced4da",
                                                borderRadius: "4px",
                                                padding: "6px 12px",
                                            }}
                                            type="select" className="custom-select"
                                            name="selectedVendorId"
                                            value={selectedVendorId}
                                            onChange={selectVendorFilter}
                                        >
                                            <option value="">-- Select Vendor --</option>
                                            {vendorState?.vendors.map((data) => (
                                                <option key={data.id} value={data.id}>
                                                    {data.vender_name}
                                                </option>
                                            ))}
                                        </Input>
                                    </FormGroup>
                                </Col>
                            )}

                            {/* Branch Filter */}
                            {(branchState?.branches?.length === 0 ||
                                branchState?.branches?.length > 1) && (
                                    <Col xl={3} md={4} sm={6} style={{ marginBottom: "15px" }}>
                                        <FormGroup>
                                            <label style={{ fontWeight: "bold", marginBottom: "5px" }}>Branch</label>
                                            <Input
                                                style={{
                                                    border: "1px solid #ced4da",
                                                    borderRadius: "4px",
                                                    padding: "6px 12px",
                                                }}
                                                type="select" className="custom-select"
                                                name="selectedBranchId"
                                                value={selectedBranchId}
                                                disabled={!selectedVendorId}
                                                onChange={selectbranchFilter}
                                            >
                                                <option value="">-- Select Branch --</option>
                                                {branchState?.branches
                                                    ?.filter((data) =>
                                                        selectedVendorId
                                                            ? String(data.vender_master_id) === String(selectedVendorId)
                                                            : true // Show all branches if no vendor is selected
                                                    )
                                                    .map((data) => (
                                                        <option key={data.id} value={data.id}>
                                                            {data.branch_name}
                                                        </option>
                                                    ))}

                                            </Input>
                                        </FormGroup>
                                    </Col>
                                )}
                        </Row>
                    </CardTitle>

                    <CardBody className="">
                        <Table striped>
                            <thead>
                                <tr>
                                    {/*  <th>S. no.</th> */}
                                    <th>Bill No.</th>
                                    <th>Bill Date</th>
                                    <th>Party  Name</th>
                                    <th>Qty</th>

                                    <th>Amt</th>

                                    {/* <th>Permit No</th>
                                    <th>Vehicle No</th> */}
                                    {/* <th>Edit</th> */}
                                    {/* <th>Delete</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {challanTable.map((item, index) => (
                                    <tr key={index}>
                                        {/* <th scope="row">{index + 1}</th> */}
                                        {/* <td>
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "start" }}>
                                                <Button
                                                    color="warning"
                                                    className="me-0 ms-2"
                                                    size="sm"
                                                    onClick={() => onHandleEditChallan(item.id)}
                                                >
                                                    <i className="fas fa-edit"></i>
                                                    <p style={{ fontSize: 8, padding: 0, margin: 0, fontWeight: "bold" }}>Edit</p>
                                                </Button>
                                                <span className='ms-2'>{item.manual_billno}</span>

                                            </div></td> */}

                                        <th scope='row' >
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "start", flexDirection: "column" }}>
                                                <span className='ms-2'>{item.manual_billno}</span>
                                                <Button
                                                    color="warning"
                                                    className="me-0 ms-2"
                                                    size="sm"
                                                    onClick={() => onHandleEditChallan(item.id)}
                                                >
                                                    <p style={{ fontSize: 12, padding: 0, margin: 0, fontWeight: "bold" }}><i className="bi bi-pencil mr-1"></i>Edit</p>
                                                </Button>
                                            </div>
                                        </th>
                                        <td>{item.bill_date?.split('T')[0]}</td>
                                        {/* <td>{item.manual_billno}</td> */}
                                        <td>{item.pname}{" "}{(item.agr_code_old)}</td>
                                        <td>{item.tot_qty}</td>
                                        <td>₹{item.final_amount}</td>

                                        {/* <td>{item?.permit_no}</td>
                                        <td>{item?.vehicleno}</td> */}
                                        {/* <td>
                                            <Button color="warning" size="bg" onClick={() => onHandleEditChallan(item.id)}>
                                                <i className="fas fa-edit"></i>
                                            </Button>
                                        </td> */}
                                        {/* <td>
                                            <Button color="danger" size="bg" onClick={() => onHandleDeleteChallan(item.id)}>
                                                Delete
                                            </Button>
                                        </td> */}
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <ReactPaginate
                            previousLabel={'Previous'}
                            nextLabel={'Next'}
                            breakLabel={'...'}
                            pageCount={totalPage} // still 4000
                            marginPagesDisplayed={1} // 1 page at start & end
                            pageRangeDisplayed={2}  // visible range around selected page
                            onPageChange={handlePageClick}
                            containerClassName={'pagination'}
                            activeClassName={'active'}

                            pageClassName={'page-item'}
                            pageLinkClassName={'page-link'}
                            previousClassName={'page-item'}
                            nextClassName={'page-item'}
                            previousLinkClassName={'page-link'}
                            nextLinkClassName={'page-link'}
                            breakClassName={'page-item'}
                            breakLinkClassName={'page-link'}
                        />
                    </CardBody>

                </Card>
            </Col>

            <CustomDateModal

                filterFlag="sale_report"

                showDateModel={showDateModel}
                setShowDateModel={setShowDateModel}

                allDateSelected={allDateSelected}
                setAllDateSelected={setAllDateSelected}

                startDate={startDate}
                setStartDate={setStartDate}

                endDate={endDate}
                setEndDate={setEndDate}

                // handleCloseModel={handleCloseModel}
                // handleFilterDate={handleFilterDate}
                getChallanData={getChallanData}
            />


        </>
    )
}


export default ReceiveChallanAgrMaster

